import { LOCALE, Locale, TEXT } from 'modules/locale'
import * as yup from 'yup'

const locale = localStorage.getItem('locale') || LOCALE.RUSSIAN
const ERR = TEXT.ERRORS[locale as Locale]

export const validationSchema = yup.object({
  email: yup.string().email(ERR.invalidEmail),
})
